import React from 'react';

import { Box, Stack } from '@mui/material';
import { Form, Formik } from 'formik';

import ThreeLevelSteps from '../../../common/steps';
import DestinationsList from './common/destinations_list';
import { MISC_DATE_ISO_DATE_ONLY_FORMAT } from '../../../../../core/constants';
import AddWarehouseDestinationDialog from "../../../common/warehouse_and_food_partner_order_form/add_warehouse_destination_dialog";
import SectionPaper from '../../../../common/section_paper';
import BottomActionBar from '../../../../common/bottom_action_bar';
import { Button, SubmitButton } from '../../../../common/button';

const MMForm = ({ form, setView, data, setData }) => {
    const initialValues = {
        destinationsList: data?.formik?.destinationsList || [],
        productsList: data?.formik?.productsList || [],
        productsForValidation: data?.formik?.productsForValidation || []
    };

    const onReturn = () => {
        setData({});
        setView(0);
    };

    const handleSubmit = (values) => {
        const documents = [
            ...values.destinationsList.map((destination, index) => (
                {
                    targetWarehouseId: destination.warehouseId,
                    documentProducts: [
                        ...values?.productsList?.[index]?.map(product => ({
                            productId: product?.productId,
                            productBatchId: product?.productBatchId,
                            quantity: product?.quantity
                        }))
                    ]
                }
            ))
        ];

        setData({
            form: { ...form, deliveryDate: form?.deliveryDate?.format(MISC_DATE_ISO_DATE_ONLY_FORMAT), documents },
            formik: values
        });
        setView(5);
    };

    const validate = (values) => {
        const errors = {};
        const productsListErrors = [];
        let hasErrors = false;
        const quantityErrorsMemory = {};

        if (!values.destinationsList || values.destinationsList.length === 0) {
            errors.destinationsList = 'Wybierz minimum 1 lokalizację';
            return errors;
        }

        values.destinationsList.forEach((_, index) => {
            if (!values.productsList[index] || values.productsList[index].length === 0) {
                productsListErrors[index] = 'Wybierz minimum 1 produkt';
                hasErrors = true;
            } else {
                const itemErrorsArray = [];
                values.productsList[index].forEach((product, productIndex) => {
                    const itemErrors = {};

                    if (!product?.quantity) {
                        itemErrors.quantity = 'Pole wymagane';
                    } else if (product?.quantity <= 0) {
                        itemErrors.quantity = 'Proszę podać wartość całkowitą dodatnią';
                    } else {
                        const productForValidation = values?.productsForValidation?.find(pfv => (pfv?.product?.id === product?.productId) && (pfv?.productBatchId === product?.productBatchId));

                        if (productForValidation) {
                            if (quantityErrorsMemory?.[product?.productBatchId]?.[product?.productId]) {
                                itemErrors.quantity = quantityErrorsMemory[product.productBatchId][product.productId];
                            } else {
                                const productsSum = values.productsList.flat()
                                    .filter(p => (p?.productId === product?.productId) && (p?.productBatchId === product?.productBatchId))
                                    .map(p => p.quantity)
                                    .reduce((accumulator, current) => accumulator + current, 0);

                                if (productForValidation.quantity < productsSum) {
                                    const errMsg = `Dostępne ${ productForValidation.quantity } szt. na magazynie źródłowym`;
                                    itemErrors.quantity = errMsg;

                                    if (!quantityErrorsMemory[product?.productBatchId]) {
                                        quantityErrorsMemory[product.productBatchId] = {};
                                    }
                                    quantityErrorsMemory[product.productBatchId][product.productId] = errMsg;
                                }
                            }
                        }
                    }

                    if (Object.keys(itemErrors).length > 0) {
                        itemErrorsArray[productIndex] = itemErrors;
                        hasErrors = true;
                    }
                });

                if (itemErrorsArray.length > 0 || productsListErrors[index]) {
                    productsListErrors[index] = productsListErrors[index] || itemErrorsArray;
                }
            }
        });

        if (hasErrors) {
            errors.productsList = productsListErrors;
        }

        return errors;
    };

    return (
        <Formik
            initialValues={ initialValues }
            validate={ validate }
            onSubmit={ handleSubmit }
        >
            { (formik) => (
                <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 } }>
                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <Stack spacing={ 3 }>
                            <ThreeLevelSteps secondStep/>

                            <SectionPaper title="Magazyny docelowe">
                                <Stack spacing={ 3 }>
                                    <DestinationsList
                                        form={ form }
                                        formik={ formik }
                                        onlyDelivery
                                    />
                                    <AddWarehouseDestinationDialog
                                        formik={ formik }
                                        sourceWarehouseId={ form?.sourceWarehouseId }
                                    />
                                </Stack>
                            </SectionPaper>
                        </Stack>
                    </Box>

                    <BottomActionBar>
                        <Box sx={ { display: 'flex', justifyContent: 'space-between', width: '100%' } }>
                            <Button variant="outlined" onClick={ onReturn }>Wróć</Button>
                            <SubmitButton type="button" onClick={ formik.submitForm }>Dalej</SubmitButton>
                        </Box>
                    </BottomActionBar>
                </Box>
            ) }
        </Formik>
    );
};

export default MMForm;